import {
  SET_FULLSCREEN_MODAL_ID
} from './types'

export const state = {
  id: null
}

export const mutations = {
  [SET_FULLSCREEN_MODAL_ID] (state, value) {
    state.id = value
  }
}

export const actions = {
  openFullscreenModal ({ commit }, id) {
    commit(SET_FULLSCREEN_MODAL_ID, id)
  },
  closeFullscreenModal ({ commit }) {
    commit(SET_FULLSCREEN_MODAL_ID, null)
  }
}

export const getters = {
  fullscreenModalVisible: (state) => (id) => {
    return state.id === id
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/common/fullscreenModal.js